import { MachinesForLocationsStore, NewMachineForLocationStore } from './machines-per-location-store';

export function setupRepositories(storeBuilder) {
  storeBuilder.addRepository(new MachinesForLocationsStore());
  storeBuilder.addRepository(new NewMachineForLocationStore());
}
